import React from "react";
import { BootstrapTable, TableHeaderColumn } from "react-bootstrap-table";
import { TableHeaderMappings } from "Lookups";
import {
  CustomExportCSVButton,
  addCreditsOnExportToCSV
} from "Components/Tables/Common";

const numberFormatter = cell => cell && cell.toLocaleString();
const nullFormatter = cell => cell;

const getFormatter = type =>
  type === "number" ? numberFormatter : nullFormatter;

const options = {
  exportCSVBtn: CustomExportCSVButton
};

const downloadDate = new Date().toISOString().split("T")[0];

const GenericTable = ({ data: { table }, geo, year }) => {
  let hide_fields = table.hide_fields
    ? table.hide_fields.concat(["id"])
    : ["id"];
  return (
    <BootstrapTable
      data={table.rows}
      striped={true}
      hover={true}
      csvFileName={`${downloadDate}-${table.name || geo}.csv`}
      exportCSV
      version="4"
      options={{
        ...options,
        onExportToCSV: addCreditsOnExportToCSV(table.rows, year)
      }}
    >
      {Object.keys(table.fields).map((field, i) => (
        <TableHeaderColumn
          key={i}
          hidden={hide_fields.includes(field)}
          dataFormat={
            (table.formatters && table.formatters[field]) ||
            getFormatter(table.fields[field].type)
          }
          headerTitle={true}
          dataField={field}
          isKey={i == 0}
          dataAlign="left"
          dataSort={true}
          csvHeader={field}
          sortFunc={
            table.sortFunc && table.sortFunc[field]
              ? table.sortFunc[field]
              : null
          }
          tdStyle={{ whiteSpace: "normal" }}
          thStyle={{ whiteSpace: "normal" }}
        >
          {TableHeaderMappings[field] || field}
        </TableHeaderColumn>
      ))}
    </BootstrapTable>
  );
};

export default GenericTable;



// WEBPACK FOOTER //
// ./components/Tables/GenericTable.js